import { drawLabel } from "./drawLabel.js";

const drawEllipsis = (container, data, onDrag) => {
  const bindingData = data
    ? [data]
    : container.datum()
      ? [container.datum()]
      : [];
  const epath = container.selectAll("path.ellipsis").data(bindingData);
  epath
    .enter()
    .append("path")
    .classed("ellipsis", true)
    .merge(epath)
    .attr("d", `M10,0  v5 l5,3 l-10,3 l10,3 l-10,3 l5,3 v5`);
  epath.exit().remove();

  drawLabel(container, data, onDrag);
};

export { drawEllipsis };
